const t = {
  name: "ArrowCircleRight",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.5857 16L13.5857 13.0001H7V11.0001H13.5857L10.5857 8.00003L11.9999 6.58582L17.4141 12L11.9999 17.4142L10.5857 16Z" fill="currentColor"/>
<path d="M1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12ZM12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as ArrowCircleRight
};
